// Invoice status enum and color constants for status chips

export enum InvoiceStatus {
  Billed = 'Billed',
  Unsettle = 'Unsettle',
  Unsettled = 'Unsettled',
  Unbilled = 'Unbilled',
  Draft = 'Draft',
  Due = 'Due',
  Overdue = 'Overdue',
  Ordered = 'Ordered',
  Unordered = 'Unordered',
  Dispensed = 'Dispensed',
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  PartiallyPaid = 'Partially Paid',
}

export const INVOICE_STATUS_COLORS: Record<InvoiceStatus, { color: string; background: string; border: string }> = {
  [InvoiceStatus.Billed]:    { color: '#3A80E2', background: '#E7EFFF', border: '#3A80E2' },
  [InvoiceStatus.Unsettle]:  { color: '#EFAE78', background: '#FFF3EA', border: '#EFAE78' },
  [InvoiceStatus.Unsettled]: { color: '#EFAE78', background: '#FFF3EA', border: '#EFAE78' },
  [InvoiceStatus.Unbilled]:  { color: '#B0A588', background: '#FFFCF6', border: '#B0A588' },
  [InvoiceStatus.Draft]:     { color: '#9E9E9E', background: '#F1F1F1', border: '#9E9E9E' },
  [InvoiceStatus.Due]:       { color: '#B59A00', background: '#FCFBEB', border: '#B59A00' },
  [InvoiceStatus.Overdue]:   { color: '#A93434', background: '#FAECEC', border: '#A93434' },
  [InvoiceStatus.Ordered]:   { color: '#1E7E34', background: '#E6F4EA', border: '#1E7E34' },
  [InvoiceStatus.Unordered]: { color: '#6B7280', background: '#FFFFFF', border: '#D1D5DB' },
  [InvoiceStatus.Dispensed]: { color: '#00897B', background: '#E0F2F1', border: '#00897B' },
  [InvoiceStatus.Paid]:      { color: '#1E7E34', background: '#E6F4EA', border: '#1E7E34' },
  [InvoiceStatus.Unpaid]:    { color: '#E53935', background: '#FFEBEE', border: '#E53935' },
  [InvoiceStatus.PartiallyPaid]: { color: '#F57C00', background: '#FFF3E0', border: '#F57C00' },
};
